function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createElement as h, forwardRef } from 'react';
import { lowlight as low } from 'lowlight/lib/core.js';
import { mapWithDepth } from './mapChildren.js';
import addMarkers from './addMarkers.js';
const defaultProps = {
  className: 'lowlight',
  inline: false,
  prefix: 'hljs-'
};
const Lowlight = /*#__PURE__*/forwardRef((rawProps, ref) => {
  const props = _objectSpread(_objectSpread({}, defaultProps), rawProps);
  if (process.env.NODE_ENV !== 'production') {
    if (!props.language && low.listLanguages().length === 0) {
      console.warn('No language definitions seems to be registered, ' + 'did you forget to call `Lowlight.registerLanguage`?');
    }
  }
  const result = props.language ? low.highlight(props.language, props.value, {
    prefix: props.prefix
  }) : low.highlightAuto(props.value, {
    prefix: props.prefix,
    subset: props.subset
  });
  let ast = result.children;
  if (props.markers && props.markers.length && ast.length) {
    ast = addMarkers(ast, {
      prefix: props.prefix,
      markers: props.markers
    });
  }
  const value = ast.length === 0 ? props.value : ast.map(mapWithDepth(0));
  const codeProps = {
    className: 'hljs',
    style: {},
    ref: null
  };
  const preProps = {
    ref,
    className: props.className
  };
  if (result.data.language) {
    codeProps.className += ' ' + result.data.language;
  }
  if (props.inline) {
    codeProps.style = {
      display: 'inline'
    };
    codeProps.className = props.className;
    codeProps.ref = ref;
  }
  const code = /*#__PURE__*/h('code', codeProps, value);
  return props.inline ? code : /*#__PURE__*/h('pre', preProps, code);
});
Lowlight.displayName = 'Lowlight';
Lowlight.registerLanguage = low.registerLanguage;
Lowlight.hasLanguage = lang => {
  return low.listLanguages().includes(lang);
};
export default Lowlight;